/* eslint-disable eqeqeq */
import { useState, useEffect } from 'react';
import { useOutletContext, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { Grid, Button } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { videoFormValidation } from '../../utils/videoFormValidationUtils';
import { getVideoById } from './Resources';
import visibilities from '../../utils/visibilities';
import { useAppProviderStore } from 'store/appProviderCopyStore';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';

function StepSix(props) {
  const { setIsLoading, setNotify } = useAppProviderStore();
  const {
    setValue,
    getValues,
    videoResponse,
    formValidation,
    setVideoResponse,
  } = props;
  const params = useParams();
  const [open, setOpen] = useState(false);
  const [, setVisibility] = useState('');
  const [selectedVisibilityLabel, setSelectedVisibilityLabel] = useState(null);
  const [auth, setAuth] = useOutletContext();
  const [, setUserProfile] = useState();
  const [nextContentSuggestion, setNextContentSuggestion] = useState();
  const [isTechnicalSheet, setIsTechnicalSheet] = useState(false);
  const [isShortDescription, setIsShortDescription] = useState(false);
  const [isFullDescription, setIsFullDescription] = useState(false);
  const [isComments, setIsComments] = useState(false);

  const maxLengthSeeMore = 50;
  useEffect(() => {
    setUserProfile(auth.getIdToken().payload['custom:user_profile']);
  }, [auth]);

  useEffect(() => {
    setOpen(open);
    // if (videoResponse?.visibility === undefined) {
    //   setVisibility(visibilities[0].name);
    //   setValue("visibility", visibilities[0].name);
    //   setSelectedVisibilityLabel(visibilities[0].value);
    // } else {}
    setVisibility(videoResponse?.visibility);
    setValue('visibility', videoResponse?.visibility);
    setVideoResponse(getValues());

    for (let item of visibilities) {
      if (videoResponse?.visibility === item.name) {
        setSelectedVisibilityLabel(item.value);
        setValue('visibility', item.name);
      }
    }

    if (videoResponse?.nextContentSuggestion?.contentId) {
      (async () => {
        let path = `/${params?.id}/versions/${params?.version}`;
        let suggestionResponse = await getVideoById(
          path,
          auth,
          setAuth,
          setIsLoading,
          setNotify
        );
        setNextContentSuggestion(suggestionResponse);
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const showAllText = val => {
    if (val === 'shortDescription') {
      setIsShortDescription(!isShortDescription);
      return isShortDescription;
    }
    if (val === 'fullDescription') {
      setIsFullDescription(!isFullDescription);
      return isFullDescription;
    }
    if (val === 'comments') {
      setIsComments(!isComments);
      return isComments;
    }
    if (val === 'technicalSheet') {
      setIsTechnicalSheet(!isTechnicalSheet);
      return isTechnicalSheet;
    }
    return val;
  };

  return (
    <div className="step-container" id="step-six">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div
            className="video_label-title"
            style={{ marginTop: 40, marginBottom: 7 }}>
            Resumo da publicação:
          </div>
        </Grid>
        <Grid item xs={12}>
          <ul className="steps_resumo" id="video-summary">
            <li id="video-summary-title">
              Título: <strong>{videoResponse?.title || null} </strong>
            </li>
            <li>
              Status:
              {videoResponse?.status === 'PUBLISHED' && (
                <strong> Publicado</strong>
              )}
              {videoResponse?.status === 'DRAFT' && <strong> Rascunho</strong>}
              {videoResponse?.status === 'TRANSCODING' && (
                <strong> Transcodificando</strong>
              )}
              {videoResponse?.status === 'ARCHIVED' && (
                <strong> Arquivado</strong>
              )}
              {videoResponse?.status === 'FAILED' && (
                <strong> Erro na Transcodificando</strong>
              )}
              {videoResponse?.status === 'EXPIRED' && (
                <strong> Expirado </strong>
              )}
              {videoResponse?.status === 'SCHEDULED' && (
                <strong> Agendado </strong>
              )}
            </li>
            <li>
              Classificação:{' '}
              <strong>{videoResponse?.ageRating || 'Não informado'}</strong>
            </li>
            <li>
              Visibilidade:{' '}
              {
                <strong>
                  {selectedVisibilityLabel !== '' &&
                  selectedVisibilityLabel !== null &&
                  selectedVisibilityLabel !== undefined
                    ? selectedVisibilityLabel
                    : videoResponse.visibility}
                </strong>
              }
            </li>
            <li>
              Visível somente nas Coleções e Séries:{' '}
              <strong>
                {videoResponse?.searchable === false ? 'Sim' : 'Não'}
              </strong>
            </li>
            <li>
              Créditos:{' '}
              {videoResponse?.personalitiesCredits?.length > 0 ? (
                videoResponse?.personalitiesCredits.map((person, index) => (
                  <strong key={index}>
                    {' '}
                    {person.label || person?.name}{' '}
                    {index < videoResponse?.personalitiesCredits.length - 1
                      ? '/'
                      : ''}
                  </strong>
                ))
              ) : (
                <strong>Não informado</strong>
              )}
            </li>
            <li>
              Com quem:{' '}
              {videoResponse?.personalities?.length > 0 ? (
                videoResponse?.personalities.map((person, index) => (
                  <strong key={index}>
                    {' '}
                    {person.label || person?.name}{' '}
                    {index < videoResponse?.personalities.length - 1 ? '/' : ''}
                  </strong>
                ))
              ) : (
                <strong>Não informado</strong>
              )}
            </li>
            <li>
              Accessibilidade:{' '}
              <strong>
                {videoResponse?.mediaWithAcessibilityId ? 'Sim' : 'Não'}
              </strong>
            </li>
            <li>
              Data de Expiração:{' '}
              <strong>
                {videoResponse?.expiresIn ? (
                  dayjs(videoResponse?.expiresIn).format('DD/MM/YYYY')
                ) : (
                  <strong>Não informado</strong>
                )}
              </strong>
            </li>
            <li>
              Ano de Criação:{' '}
              <strong>
                {videoResponse?.launchYear ? (
                  videoResponse?.launchYear
                ) : (
                  <strong>Não informado</strong>
                )}
              </strong>
            </li>
            <li>
              Paises de Origem:{' '}
              {videoResponse?.launchingCountry?.length > 0 ? (
                videoResponse?.launchingCountry.map((country, index) => (
                  <strong key={index}>
                    {' '}
                    {country.label || country?.name}{' '}
                    {index < videoResponse?.launchingCountry.length - 1
                      ? '/'
                      : ''}
                  </strong>
                ))
              ) : (
                <strong>Não informado</strong>
              )}
            </li>
            <li>
              Paises permitidos:{' '}
              {videoResponse?.allowedCountries?.length > 0 ? (
                videoResponse?.allowedCountries?.map((country, index) => (
                  <strong key={index}>
                    {country.name || country.label}{' '}
                    {index < videoResponse?.allowedCountries.length - 1
                      ? '/ '
                      : ''}
                  </strong>
                ))
              ) : (
                <strong>Não informado</strong>
              )}
            </li>
            <li>
              Paises não permitidos:{' '}
              {videoResponse?.deniedCountries?.length > 0 ? (
                videoResponse?.deniedCountries?.map((country, index) => (
                  <strong key={index}>
                    {country.name || country.label}{' '}
                    {index < videoResponse?.deniedCountries.length - 1
                      ? '/ '
                      : ''}
                  </strong>
                ))
              ) : (
                <strong>Não informado</strong>
              )}
            </li>
            <li>
              Unidade(s):{' '}
              {videoResponse?.units?.length > 0 ? (
                videoResponse?.units.map((unit, index) => (
                  <strong key={index}>
                    {unit.label || unit?.name}{' '}
                    {index < videoResponse?.units.length - 1 ? '/' : ''}{' '}
                  </strong>
                ))
              ) : (
                <strong>Não informado</strong>
              )}
            </li>
            <li>
              Canal(is):{' '}
              {videoResponse?.channels?.length > 0 ? (
                videoResponse?.channels.map((channel, index) => (
                  <strong key={index}>
                    {' '}
                    {channel.label || channel?.name}{' '}
                    {index < videoResponse?.channels.length - 1 ? '/' : ''}
                  </strong>
                ))
              ) : (
                <strong>Não informado</strong>
              )}
            </li>
            <li>
              Palavras-chave:{' '}
              {videoResponse?.keywords?.length > 0 ? (
                videoResponse?.keywords.map((word, index) => (
                  <strong key={index}>
                    {word?.value && (
                      <strong>
                        {word.key} - {word.value.toString()}{' '}
                        {index < videoResponse?.keywords.length - 1 ? '/ ' : ''}
                      </strong>
                    )}
                  </strong>
                ))
              ) : (
                <strong>Não informado</strong>
              )}
            </li>
            <li>
              Limite de Players:{' '}
              <strong>
                {videoResponse?.viewsLimit
                  ? videoResponse?.viewsLimit
                  : 'Não informado'}
              </strong>
            </li>
            <li>
              <strong>
                {nextContentSuggestion?.nextContentSuggestion?.id
                  ? nextContentSuggestion?.nextContentSuggestion?.title
                  : ''}
              </strong>
            </li>
            <li>
              Próxima sugestão em:{' '}
              <strong>
                {videoResponse?.nextSuggestionTimeSeconds
                  ? videoResponse?.nextSuggestionTimeSeconds
                  : 'Não informado'}
              </strong>
            </li>
            <li>
              Coleções associadas:{' '}
              {videoResponse?.collections?.length > 0 ? (
                videoResponse?.collections.map((collection, index) => (
                  <strong key={index}>
                    {collection.title}{' '}
                    {index < videoResponse?.collections.length - 1 ? '/' : ''}{' '}
                  </strong>
                ))
              ) : (
                <strong>Não informado </strong>
              )}
            </li>
            {/* <li>
  Áudio:{' '}
  <strong>{videoResponse?.languageId || 'Não informado'}</strong>
</li>
<li>
  Legendas:{' '}
  <strong>{videoResponse?.languageId || 'Não informado'}</strong>
</li> */}

            <li>
              Trailer:{' '}
              <strong>{videoResponse?.trailerId ? 'Sim' : 'Não'} </strong>
            </li>
            {/* <li>
  Contratos:{' '}
  {videoResponse?.relatedFiles?.length > 0 ? (
    videoResponse?.relatedFiles.map((file, index) => (
      <strong key={index}>
        {' '}
        {file.name}{' '}
        {index < videoResponse?.relatedFiles.length - 1 ? '/' : ''}
      </strong>
    ))
  ) : (
    <strong>Não informado</strong>
  )}
</li>
<li>
  Arquivos relacionados:{' '}
  <strong>
    {videoResponse?.relatedFiles?.length > 0 ? (
      videoResponse?.relatedFiles.map((file, index) => (
        <strong key={index}>
          {file.url}{' '}
          {index < videoResponse?.relatedFiles.length - 1
            ? '/'
            : ''}{' '}
        </strong>
      ))
    ) : (
      <strong>Não informado</strong>
    )}
  </strong>
</li> */}

            <li>
              Thumbnail:{' '}
              <strong>
                {videoResponse?.thumbnails?.length > 0 ? 'Sim' : 'Não'}{' '}
              </strong>
            </li>
            {videoResponse?.technicalSheet?.length <= maxLengthSeeMore && (
              <li>
                Ficha técnica: &nbsp;
                <strong>
                  {videoResponse?.technicalSheet || 'Não informado'}
                </strong>
              </li>
            )}

            {videoResponse?.technicalSheet?.length > maxLengthSeeMore && (
              <li style={{ position: 'relative' }}>
                <div className={isTechnicalSheet ? 'no-ellipsis' : 'ellipsis'}>
                  Ficha técnica: &nbsp;
                  <strong>
                    {videoResponse?.technicalSheet || 'Não informado'}
                  </strong>
                </div>
                <Button
                  onClick={() => showAllText('technicalSheet')}
                  variant="text"
                  color="primary"
                  size="small"
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    textTransform: 'capitalize',
                  }}>
                  {isTechnicalSheet ? 'Ver Menos' : 'Ver Mais'}
                  {isTechnicalSheet ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )}
                </Button>
              </li>
            )}

            {videoResponse?.shortDescription?.length <= maxLengthSeeMore && (
              <li>
                Descrição curta: &nbsp;
                <strong>
                  {videoResponse?.shortDescription || 'Não informado'}
                </strong>
              </li>
            )}
            {videoResponse?.shortDescription?.length > maxLengthSeeMore && (
              <li style={{ position: 'relative' }}>
                <div
                  className={isShortDescription ? 'no-ellipsis' : 'ellipsis'}>
                  Descrição curta: &nbsp;
                  <strong>
                    {videoResponse?.shortDescription || 'Não informado'}
                  </strong>
                </div>
                <Button
                  onClick={() => showAllText('shortDescription')}
                  variant="text"
                  color="primary"
                  size="small"
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    textTransform: 'capitalize',
                  }}>
                  {isShortDescription ? 'Ver Menos' : 'Ver Mais'}
                  {isShortDescription ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )}
                </Button>
              </li>
            )}
            {videoResponse?.fullDescription?.length <= maxLengthSeeMore && (
              <li>
                Descrição longa:&nbsp;
                <strong>
                  {videoResponse?.fullDescription || 'Não informado'}
                </strong>
              </li>
            )}
            {videoResponse?.fullDescription?.length > maxLengthSeeMore && (
              <li style={{ position: 'relative' }}>
                <div className={isFullDescription ? 'no-ellipsis' : 'ellipsis'}>
                  Descrição longa: &nbsp;
                  <strong>
                    {videoResponse?.fullDescription || 'Não informado'}
                  </strong>
                </div>
                <Button
                  onClick={() => showAllText('fullDescription')}
                  variant="text"
                  color="primary"
                  size="small"
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    textTransform: 'capitalize',
                  }}>
                  {isFullDescription ? 'Ver Menos' : 'Ver Mais'}
                  {isFullDescription ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )}
                </Button>
              </li>
            )}
            {videoResponse?.comments?.length <= maxLengthSeeMore && (
              <li>
                Observações gerais:&nbsp;
                <strong>{videoResponse?.comments || 'Não informado'}</strong>
              </li>
            )}
            {videoResponse?.comments?.length > maxLengthSeeMore && (
              <li style={{ position: 'relative' }}>
                <div className={isComments ? 'no-ellipsis' : 'ellipsis'}>
                  Observações gerais: &nbsp;
                  <strong>{videoResponse?.comments || 'Não informado'}</strong>
                </div>
                <Button
                  onClick={() => showAllText('comments')}
                  variant="text"
                  color="primary"
                  size="small"
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    textTransform: 'capitalize',
                  }}>
                  {isComments ? 'Ver Menos' : 'Ver Mais'}
                  {isComments ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )}
                </Button>
              </li>
            )}
          </ul>
        </Grid>

        {formValidation != undefined && formValidation.length > 0 && (
          <Grid
            item
            xs={13}
            sx={{ backgroundColor: '#ddedff', margin: 5, borderRadius: 6 }}>
            <Grid item xs={12}>
              <div
                className="video_label-title_validation"
                style={{ marginTop: 10 }}>
                Campos obrigatórios não preenchidos!
              </div>
              <div className="video_label-title_validation_2">
                Por favor, preencha os campos abaixo para que seja possível
                publicar seu vídeo:
              </div>
            </Grid>
            <div style={{ marginLeft: 15, marginBottom: 15 }}>
              {formValidation.map((items, index) => {
                return (
                  <li
                    key={index}
                    style={{ listStyleType: 'none', fontSize: 15 }}>
                    <ReportGmailerrorredIcon
                      fontSize="small"
                      sx={{ color: 'red' }}
                    />{' '}
                    {videoFormValidation[items]}
                  </li>
                );
              })}
            </div>
          </Grid>
        )}
        <Grid item xs={4}></Grid>
      </Grid>
    </div>
  );
}

export default StepSix;
